import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Body, Footer } from '@calendly/ui/components/popup'
import { useSelector, useDispatch } from 'react-redux'

import { fetchCurrentSubscriptionAndNextBill } from 'features/billing/actions/fetch_current_subscription_and_next_bill'
import { fetchTransactionHistory } from 'features/billing/actions/fetch_transaction_history'
import { resetPaymentStatus } from 'features/billing/payment_slice'
import { ownerEmailSelector } from 'selectors/current_organization'

export const SuccessPopup = ({ onClose, isScheduled, newQuantity, billingDate }) => {
  const email = useSelector(ownerEmailSelector)
  const dispatch = useDispatch()
  const onPopupClose = () => {
    dispatch(resetPaymentStatus())
    dispatch(fetchCurrentSubscriptionAndNextBill())
    dispatch(fetchTransactionHistory())
    onClose()
  }
  const title = isScheduled
    ? I18n.t('publisher.billing.scheduled_downgrade.success.header')
    : I18n.t('publisher.billing.success.quantity_change_success')
  return (
    <Popup
      title={title}
      onClose={onPopupClose}
    >
      <Body>
        {isScheduled
          ? I18n.t('publisher.billing.scheduled_downgrade.success.message.quantity', {
            count: newQuantity,
            billing_date: billingDate
          })
          : I18n.t('publisher.billing.success.receipt_emailed', { email })}
      </Body>
      <Footer>
        <Button onClick={onPopupClose}>
          {I18n.t('publisher.action.ok')}
        </Button>
      </Footer>
    </Popup>
  )
}
